import factory from './factory';

factory('[widget=login]');



// WEBPACK FOOTER //
// ./index.js